﻿'use strict';

angular.module('ntmApp').factory('StaffInfo', ['ForecastService', function (ForecastService) {

    function StaffInfo() {

        var self = this;

        self.config = {
            workHours: {
                expanded: false
            },

            locationAssignments: {
                expanded: false
            },

            upcomingPTO: {
                expanded: false
            },

            upcomingOT: {
                expanded: false
            },

            skills: {
                expanded: false
            },

            setDefaultConfigs: function() {
                this.workHours.expanded = false;
                this.locationAssignments.expanded = false;
                this.upcomingPTO.expanded = false;
                this.upcomingOT.expanded = false;
                this.skills.expanded = false;
            }
        };

        self.selectPersonInStaffInfoPane = function (selectedWeek, personId, forecastMode, scenarioId) {

            if (personId && self.staffContacts) {
                var person = self.staffContacts.firstOrDefault(function (staff) {
                    return staff.id === personId;
                });

                if (person) {
                    self.selectedStaff = person;
                    loadStaffInfo({
                        personId: personId,
                        forecastMode: forecastMode,
                        scenarioBreadcrumb: scenarioId,
                        dateFrom: selectedWeek.startDate,
                        dateTo: selectedWeek.endDate
                    });
                }
            }
        };

        self.clear = function () {
            self.selectedStaff = null;
            self.currentStaffInfo = null;
        };

        self.clearStaffInfoOnly = function () {
            self.currentStaffInfo = null;
        };

        self.toggleWorkHours = function () {
            self.config.workHours.expanded = !self.config.workHours.expanded;
        };

        self.toggleLocationAssignments = function () {
            self.config.locationAssignments.expanded = !self.config.locationAssignments.expanded;
        };

        self.toggleUpcomingPTO = function () {
            self.config.upcomingPTO.expanded = !self.config.upcomingPTO.expanded;
        };

        self.toggleUpcomingOT = function () {
            self.config.upcomingOT.expanded = !self.config.upcomingOT.expanded;
        };

        self.toggleSkills = function () {
            self.config.skills.expanded = !self.config.skills.expanded;
        };

        function loadStaffInfo(request) {

            if (self.selectedStaff) {

                self.loading = true;
                self.config.setDefaultConfigs();

                ForecastService.GetStafInfo(request).then(function (result) {

                    if (result.success) {
                        self.currentStaffInfo = {
                            staffInfoPTOList: result.data.staffInfoPTOList || [],
                            staffInfoOTList: result.data.staffInfoOvertimes || [],
                            staffInfoWorkHours: result.data.staffInfoWorkHours || [],
                            staffLocations: result.data.staffLocations || [],
                            staffSkills: result.data.staffSkills || [],
                            staffContact: result.data.staffContact
                        };

                    }

                    self.loading = false;
                });
            }
        }
    }

    return (StaffInfo);
}]);